<template>
  <div class="platform__pc" :class="{ 'no-min-width': isNewcomponentMlz }">
    <nuxt />
  </div>
</template>

<script>
export default {
  computed: {
    isNewcomponentMlz() {
      return this.$route.path && (this.$route.path.includes('newcomponent-mlz') || this.$route.path.includes('prwalkthrough') || this.$route.path.includes('newfive') || this.$route.path === '/');
    },
  },
}
</script>
